<template>
  <Loading
    :contentSize="true"
    :state="loading"
    class="mainLoading"
  >
    <div class="row">
      {{ $t( "DataSource" ) }}:
      <Autocompleter
        :value="dataSource"
        @input="dataSource=$event"
        :getItems="dataSourceItems"
        @ok="dataSource=$event"
      />
    </div>

    <template v-if="dataSource && dataSource.id">
      <div class="row">
        {{ $t( "Db" ) }}:
        <Autocompleter
          :value="db"
          @input="db=$event"
          :getItems="dbsItems"
          @ok="db=$event"
        />
      </div>

      <template v-if="db && db.id">
        <div class="row">
          {{ $t( "DbSchema" ) }} "<b>{{db.name}}</b>":
          <Autocompleter
            :value="dbSchema"
            @input="dbSchema=$event"
            :getItems="dbSchemasItems"
            @ok="dbSchema=$event"
          />
        </div>

        <template v-if="dbSchema && dbSchema.id">
          <div class="row">
            {{ $t( "DbTable" ) }} "<b>{{db.name}}.{{dbSchema.name}}</b>":
            <Autocompleter
              :value="dbTable"
              @input="dbTable=$event"
              :getItems="dbTablesItems"
              @ok="dbTable=$event"
            />
          </div>

          <template v-if="dbTable && dbTable.id && dbColumns">
            <template v-if="properitesMapped">
              <div class="row">
                <b>{{ $t( "MetadataLoadingFinished" ) }}.</b><br /><br />
                {{ $t( "TablePropertiesCreated" ) }} "<b>{{dbTable.name}}</b>" {{ $t( "dbFor" ) }} "<b>{{db.name}}.{{dbSchema.name}}</b>"

                <table class="tbl" cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <th>{{ $t( "TableProp" ) }}</th>
                    <th>{{ $t( "TablePropMapping" ) }}</th>
                  </tr>
                  <tr
                    v-for="p in properitesMapped"
                    :key="p"
                  >
                    <td>{{ colByProp( p ) }}</td>
                    <td>
                      <a
                        :href="`/editor/${encodeURIComponent( endpoint )}/http%3A%2F%2Fdatavera.kz%2Fekg%2FPredicateMap/object/${encodeURIComponent( p )}`"
                        target="_blank">
                        {{ p }}
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
            <template v-else>
              <div class="row">
                {{ $t( "TableColumns" ) }} "<b>{{dbTable.name}}</b>" {{ $t( "dbFor" ) }} "<b>{{db.name}}.{{dbSchema.name}}</b>"

                <table v-if="dbColumns" class="tbl" cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <th>{{ $t( "TableColumnsName" ) }}</th>
                    <th>{{ $t( "TableColumnsType" ) }}</th>
                    <th>{{ $t( "TableColumnsLen" ) }}</th>
                  </tr>
                  <tr
                    v-for="col in dbColumns"
                    :key="col.name"
                  >
                    <td>{{ col.name }}</td>
                    <td>{{ col.type }}</td>
                    <td>{{ col.length }}</td>
                  </tr>
                </table>
              </div>

              <div class="row load">
                <Button
                 @click="metadataLoad"
                 class="button"
                >
                  {{ $t( "MetadataLoad" ) }}
                </Button>
              </div>
            </template>
          </template>
        </template>
      </template>
    </template>
  </Loading>
</template>

<script>
  import utils from "@/utils";
  import dates from "@/dates";
  import fbu from "../frontbackUtils.js";

  import Loading from "@/components/Loading";
  import Icon from "@/components/Icon";
  import Modal from "@/components/Modal";
  import Tooltip from "@/components/Tooltip";
  import Button from "@/components/Button";
  import Autocompleter from "@/components/Autocompleter";


  import ObjectEditor from "./ObjectEditor";

  export default {
		name:  "OpenMetadata",

    components: {
		  Loading,
      Icon,
      Modal,
      Tooltip,
      Button,
      Autocompleter
    },

    utils,

    i18n: {
      messages: {
        ru: {
          OpenMetadataTitle: "Работа с OpenMetadata",
          DataSourcesRequestErr: "Ошибка запроса источников данных",
          DatabasesRequestErr: "Ошибка запроса баз данных",
          DatabaseSchemasRequestErr: "Ошибка запроса схем базы данных",
          DatabaseTablesRequestErr: "Ошибка запроса таблиц базы данных",
          DatabaseColumnsRequestErr: "Ошибка запроса столбцов базы данных",
          MetadataLoad: "Загрузить метаданные",
          MetadataLoadingRequestErr: "Ошибка зарузки метаданных",
          DataSource: "Источник данных",
          Db: "База данных",
          DbSchema: "Схема базы данных",
          DbTable: "Таблица базы данных",
          MetadataLoadingFinished: "Загрузка метаданных завершена",
          TablePropertiesCreated: "Созданы свойства для таблицы",
          dbFor: "базы данных",
          TableProp: "Свойство таблицы",
          TablePropMapping: "Мэппинг",
          TableColumns: "Столбцы таблицы",
          TableColumnsName: "Название",
          TableColumnsType: "Тип",
          TableColumnsLen: "Длина"
        },

        en: {
          OpenMetadataTitle: "Work with OpenMetadata",
          DataSourcesRequestErr: "Data sources request error",
          DatabasesRequestErr: "Databases request error",
          DatabaseSchemasRequestErr: "Database schemas request error",
          DatabaseTablesRequestErr: "Database tables request error",
          DatabaseColumnsRequestErr: "Database columns request error",
          MetadataLoad: "Load metadata",
          MetadataLoadingRequestErr: "Metadata loading error",
          DataSource: "Data source",
          Db: "Database",
          DbSchema: "Database schema",
          DbTable: "Database table",
          MetadataLoadingFinished: "Metadata loading has been finished",
          TablePropertiesCreated: "Properties have been created for the table",
          dbFor: "for database",
          TableProp: "Table property",
          TablePropMapping: "Mapping",
          TableColumns: "Table columns",
          TableColumnsName: "Name",
          TableColumnsType: "Type",
          TableColumnsLen: "Length"
        },

        kz: {
          OpenMetadataTitle: "OpenMetadata-мен жұмыс істеу",
          DataSourcesRequestErr: "Деректер көздері сұрау қатесі",
          DatabasesRequestErr: "Мәліметтер қорын сұрау қатесі",
          DatabaseSchemasRequestErr: "Дерекқор схемаларын сұрау қатесі",
          DatabaseTablesRequestErr: "Мәліметтер қоры кестелеріне сұраныс қатесі",
          DatabaseColumnsRequestErr: "Дерекқор бағандары сұрау қатесі",
          MetadataLoad: "Метадеректерді жүктеңіз",
          MetadataLoadingRequestErr: "Метадеректерді жүктеу қатесі",
          DataSource: "Деректер көзі",
          Db: "Мәліметтер қоры",
          DbSchema: "Мәліметтер базасының схемасы",
          DbTable: "Мәліметтер базасының кестесі",
          MetadataLoadingFinished: "Метадеректерді жүктеу аяқталды",
          TablePropertiesCreated: "Кесте үшін сипаттар жасалды",
          dbFor: "мәліметтер базасы үшін",
          TableProp: "Кесте қасиеті",
          TablePropMapping: "Картаға түсіру",
          TableColumns: "Кесте бағандары",
          TableColumnsName: "Аты",
          TableColumnsType: "Түр",
          TableColumnsLen: "Ұзындығы"
        }
      }
    },

    props: {
      endpoint: {
        type: String,
        mandatory: true
      }
    },

    data() {
		  return {
		    loading: false,

        dataSource: { id: null, name: null },
        db:         { id: null, name: null },
        dbSchema:   { id: null, name: null },
        dbTable:    { id: null, name: null },
        dbColumns:  null,
        properitesMapped: null
      };
    },

    mounted() {
		  if ( !this.permitted( "openMetadata", this.endpoint ) ) this.close();
    },

    methods: {
      close() {
        const path = this.$route.path.replace( /\/openMetadata\/.*$/, "" );
        this.$router.push( path ? path : "/" );
      },

      async dataSourceItems() {
        try {
          const ans = await this.$options.api.post.json(
            "/openMetadata/dataSources",
            {
              ...this.queryStd,
              clientId: this.clientId,
              endpoint: this.endpoint
            }
          );

          if ( !ans ) throw new Error( "malformed server answer" );
          if ( ans.error ) throw new Error( ans.error );
          if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
          if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

          return ans.items;
        }
        catch ( e ) {
          console.error( "SOURCES REQUEST ERROR: " + e.message, e.stack );
          this.$root.$emit( "notify", { header: this.$t( 'SourcesRequestErr' ), message: e.message, type: "error" } );
        }

        return [];
      },

      async dbItems( type, query ) {
        let typeErr, typeHumanErr;

        if ( !query ) query = {};

        switch ( type ) {
          case "dbs":
            typeErr = "DATABASES REQUEST ERROR";
            typeHumanErr = this.$t( "DatabasesRequestErr" );
          break;

          case "dbSchemas":
            typeErr = "DATABASE SCHEMAS REQUEST ERROR";
            typeHumanErr = this.$t( "DatabaseSchemasRequestErr" );
          break;

          case "dbTables":
            typeErr = "DATABASE TABLES REQUEST ERROR";
            typeHumanErr = this.$t( "DatabaseTablesRequestErr" );
          break;

          case "dbColumns":
            typeErr = "DATABASE COLUMNS REQUEST ERROR";
            typeHumanErr = this.$t( "DatabaseColumnsRequestErr" );
          break;
        }

        try {
          const ans = await this.$options.api.post.json(
            "/openMetadata/dbs",
            {
              ...this.queryStd,
              clientId: this.clientId,
              endpoint: this.endpoint,
              type,
              ...query
            }
          );

          if ( !ans ) throw new Error( "malformed server answer" );
          if ( ans.error ) throw new Error( ans.error );
          if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
          if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

          return ans.items;
        }
        catch ( e ) {
          console.error( typeErr + ": " + e.message, e.stack );
          this.$root.$emit( "notify", { header: typeHumanErr, message: e.message, type: "error" } );
        }

        return [];
      },

      async dbsItems() {
        return await this.dbItems( "dbs" );
      },
      async dbSchemasItems() {
        return await this.dbItems( "dbSchemas", { dbId: this.db.id } );
      },
      async dbTablesItems() {
        return await this.dbItems( "dbTables", { dbId: this.db.id, dbSchemaId: this.dbSchema.id } );
      },
      async dbColumnsItems() {
        return await this.dbItems( "dbColumns", { dbId: this.db.id, dbSchemaId: this.dbSchema.id, dbTableId: this.dbTable.id } );
      },

      async metadataLoad() {
        this.loading = true;

        try {
          const ans = await this.$options.api.put.json(
            "/openMetadata/metadata",
            {
              ...this.queryStd,
              clientId:     this.clientId,
              endpoint:     this.endpoint,
              dataSourceId: this.dataSource.id,
              dbId:         this.db.id,
              dbSchemaId:   this.dbSchema.id,
              dbTableId:    this.dbTable.id
            }
          );

          if ( !ans ) throw new Error( "malformed server answer" );
          if ( ans.error ) throw new Error( ans.error );
          if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
          if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

          this.properitesMapped = ans.items;
        }
        catch ( e ) {
          console.error( "METADATA LOADING REQUEST ERROR: " + e.message, e.stack );
          this.$root.$emit( "notify", { header: this.$t( 'MetadataLoadingRequestErr' ), message: e.message, type: "error" } );
        }

        this.loading = false;
      },

      colByProp( p ) {
        for ( const c of this.dbColumns ) {
          const n = c.name;
          if ( String( p ).endsWith( n ) ) return n;
        }

        return "-";
      }
    },

    computed: {
    },

    watch: {
		  async db() {
		    this.dbSchema = { id: null, name: null };
      },

		  async dbSchema() {
		    this.dbTable = { id: null, name: null };
      },

		  async dbTable() {
		    if ( this.dbTable.id ) {
          this.loading = true;
          this.dbColumns = await this.dbColumnsItems();
          this.loading = false;
        }
		    else {
		      this.dbColumns = null;
		      this.properitesMapped = null;
        }
      }
    }
  };
</script>

<style scoped>
.autocomplete {
  max-width: 15em;
}

.row {
  margin-top: 1em;
}
.row:first-child {
  margin-top: 0;
}

.row.load {
  margin-top: 2em;
}

.tbl {
  border: solid 1px #808080;
}
.tbl > tbody > tr > th,
.tbl > tbody > tr > td,
.tbl > tr > th,
.tbl > tr > td {
  padding: 0 1em;
  border: solid #808080;
  border-width: 0 1px 1px 0;
  border-radius: 0;
  text-align: left;
  vertical-align: top;
}
.tbl > tbody > tr > th:last-child,
.tbl > tbody > tr > td:last-child,
.tbl > tr > th:last-child,
.tbl > tr > td:last-child  {
  border-right-width: 0;
}
.tbl > tbody > tr:last-child > th,
.tbl > tbody > tr:last-child > td,
.tbl > tr:last-child > th,
.tbl > tr:last-child > td {
  border-bottom-width: 0;
}

.tbl > tbody > tr > th,
.tbl > tr > th {
  background-color: #F2F6FB;
  color: #4D4D4D;
  font-weight: bold;
}

.tbl > tbody > tr > td,
.tbl > tr > td {
  color: #212121;
}
</style>